import step from 'store/modules/personal/step';
import claimant from './claimant';
import generalDamages from './generalDamages';
import cruBenefits from './cruBenefits';
import interimPayments from './interimPayments';
import calculateLoss from './calculateLoss';
import lossOfIncome from './lossOfIncome';
import pastLossOfEarnings from './pastLossOfEarnings';
import futureLosses from './futureLosses';
import otherPastLosses from './otherPastLosses';
import otherFutureLosses from './otherFutureLosses';
import claimantDetails from './claimantDetails';
import documents from './documents';

/**
 * Claim Type.
 *
 * @type {String}
 */
const claimType = 'personal_injury';

/**
 * Mutation Types
 *
 * @type {Object}
 */
const mutationTypes = {};

/**
 * State.
 *
 * @type {Object}
 */
const state = {};

/**
 * Getters.
 *
 * @type {Object}
 */
const getters = {};

/**
 * Actions.
 *
 * @type {Object}
 */
const actions = {
    /**
     * Dispatches save requests to the correct step.
     */
    save({commit, dispatch, rootGetters}, payload) {
        let individualStep = rootGetters['personal/step/allSteps'][payload.step_number];

        return dispatch('personal/' + individualStep.store + '/save', payload, {root: true});
    },
    /**
     * Dispatches loading of a step requests to the correct step.
     */
    load({commit, dispatch, rootGetters}, step) {
        let individualStep = rootGetters['personal/step/allSteps'][parseInt(step.step_number, 10)];

        dispatch('checkForStepStore', individualStep)
            .then(() => dispatch('personal/' + individualStep.store + '/load', step, {root: true}));
    },
    /**
     * Dispatches process requests to the correct step.
     */
    process({commit, dispatch, rootState}, step) {
        dispatch('checkForStepStore', step)
            .then(() => dispatch('personal/' + step.store + '/process', step, {root: true}));
    },
    /**
     * Dispatches validate requests to the correct step.
     */
    validate({commit, dispatch, rootState}, step) {
        dispatch('checkForStepStore', step)
            .then(() => dispatch('personal/' + step.store + '/validate', step, {root: true}));
    },
    /**
     * Dispatches reset requests to the correct step.
     */
    reset({commit, dispatch}, step) {
        dispatch('checkForStepStore', step)
            .then(() => dispatch('personal/' + step.store + '/reset', step, {root: true}));
    },
    /**
     * Checks that a Step has its store defined in the routes, otherwise throws an error.
     */
    checkForStepStore(noop, individualStep) {
        if (!individualStep.store) {
            throw {'error': 'Step #' + individualStep.step + ' (' + individualStep.name + ') does not have a store defined in the routes meta'};
        }
    }
};

/**
 * Mutations
 *
 * @type {Object}
 */
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        step,
        claimant,
        claimantDetails,
        generalDamages,
        cruBenefits,
        interimPayments,
        calculateLoss,
        lossOfIncome,
        pastLossOfEarnings,
        futureLosses,
        otherPastLosses,
        otherFutureLosses,
        documents
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/index.js